import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=62b29c58&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=62b29c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b29c58",
  null
  
)

export default component.exports